<template>
  <div class="checkImgPoint">
    <div class="searchHead">
      <el-form label-position="top" size="small" class="searchForm">
        <el-form-item label=" ">
          <el-select v-model="versionValue" style="width: 100%" placeholder="请选择" filterable
            @change="versionFunSelect()">
            <el-option v-for="item in versionFunction" :key="item.id" :label="item.cnName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=" ">
          <el-select v-model="selectValue" style="width: 100%" placeholder="请选择" filterable @change="selectPart()">
            <el-option v-for="item in optionsFunction" :key="item.id" :label="item.cnName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=" ">
          <el-select v-model="specValue" placeholder="请选择" style="width: 100%" filterable @change="selectMajor()">
            <el-option v-for="item in optionsSpec" :key="item.id" :label="item.cnName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="bottomInfo">
      <div class="leftTree">
        <el-input v-model="navValue" size="small" placeholder="请输入目录名称">
          <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="navSearch"></i>
        </el-input>
        <el-tree ref="tree" v-loading="loading" :data="treeData" :props="defaultProps" :filter-node-method="filterNode"
          class="filter-tree dataTree" style="border: 1px solid gainsboro;margin-top: 3px" default-expand-all
          @node-click="handleNodeClick">
        </el-tree>
      </div>
      <div class="rightTable">
        <el-input v-model="messageValue" size="small" placeholder="请输入要点名称">
          <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="messageSearchC1"></i>
        </el-input>
        <div class="tableHead">
          <div class="headPart">
            <label>审图要点</label>
            &nbsp;
            <span>分值：{{ num }}</span>
          </div>
          <el-button type="primary" style="float: right" size="small" @click="choose">
            选择
          </el-button>
        </div>
        <ul style="overflow: auto;height: 220px" class="infoUlContent">
          <li v-for="(item, index) in messageItem" :key="index" :class="{ checked: index == n }"
            @click="chooseInfo(item, index)">
            <p v-if="item == '暂无数据'">
              暂无数据
            </p>
            <div v-else>
              <p v-for="(a,num) in item.mainPoint.replace(/\&quot;/g,&quot;&quot;).split(&quot; &quot;)" :key="num"
                v-html="markerWork(a)"></p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import checkDrawingsService from "@/CommonDP/service/checkPoint-service";

export default {
  name: "Index",
  data() {
    return {
      format: "",
      imgPoint: true,
      dataDown: true,
      navValue: "",
      radio: "",
      n: null,
      data: [
        {
          id: 1,
          label: "一级 1",
          children: [
            {
              id: 4,
              label: "二级 1-1",
              children: [
                {
                  id: 9,
                  label: "三级 1-1-1"
                },
                {
                  id: 10,
                  label: "三级 1-1-2"
                }
              ]
            }
          ]
        },
        {
          id: 2,
          label: "一级 2",
          children: [
            {
              id: 5,
              label: "二级 2-1"
            },
            {
              id: 6,
              label: "二级 2-2"
            }
          ]
        },
        {
          id: 3,
          label: "一级 3",
          children: [
            {
              id: 7,
              label: "二级 3-1"
            },
            {
              id: 8,
              label: "二级 3-2"
            }
          ]
        }
      ],
      liStyle: "infoContent",
      treeData: [],
      loading: false,
      defaultProps: {
        children: "dictTree",
        label: "cnName"
      },
      num: "",
      messageItem: [],
      specValue: "",
      optionsSpec: [],
      versionValue: "",
      versionFunction: [],
      selectValue: "",
      optionsFunction: [],
      messageValue: "",
      messParams: {
        roomID: "", // 点击的id
        queryKeyWord: ""
      },
      infoTemp: ""
    };
  },
  watch: {},
  created() {
    this.getAlldata();
  },

  methods: {
    markerWork(a) {
      const word = this.messageValue;
      const reg = new RegExp(word, "g");
      return a.replace(reg, `<b>${word}</b>`);
    },
    // 点击树
    handleNodeClick(data) {
      this.messageShow = false;
      this.messageValue = "";
      this.num = "";
      this.infoTemp = "";
      this.n = null;
      if (data.dictTree) {
        this.messParams.roomID = data.id;
        this.getDesignStandard();
      }
    },
    async getDesignStandard() {
      this.messageItem = [];
      this.messageValue = "";
      this.messParams.queryKeyWord = "";
      const result = await checkDrawingsService.designStandard(this.messParams);
      if (result.result === "0") {
        if (result.data.length === "0") {
          this.messageItem = ["暂无数据"];
        } else {
          this.messageShow = true;
          this.messageItem = result.data;
          this.n = 0;
          this.infoTemp = result.data[0];
          this.num = result.data[0].score;
        }
      }
    },

    messageSearchC1() {
      this.n = null;
      this.messParams.queryKeyWord = this.messageValue;
      this.getDesignStandardC1();
    },
    async getDesignStandardC1() {
      this.messageItem = [];
      var params = {};
      if (this.specValue === "") {
        params = {
          dicCode: this.selectValue,
          queryKeyWord: this.messageValue
        };
      } else {
        params = {
          dicCode: this.specValue,
          queryKeyWord: this.messageValue
        };
      }
      const result = await checkDrawingsService.queryByKeyWord(params);
      if (result.result === "0") {
        if (result.data.length === "0") {
          this.messageItem = ["暂无数据"];
        } else {
          this.messageShow = true;
          this.messageItem = result.data;
          this.infoTemp = "";
        }
      }
    },
    async getAlldata() {
      this.num = "";
      const result = await checkDrawingsService.getAlldata();
      if (result.result === "0") {
        this.versionFunction = result.data;
        this.versionValue = result.data[0].id;
        this.versionFunSelect();
      }
    },
    // 业态
    versionFunSelect() {
      this.selectValue = "";
      this.treeData = [];
      this.specValue = "";
      var stage = [];

      for (const a of this.versionFunction) {
        if (a.id === this.versionValue) {
          stage = a.dictTree;
          if (stage.length > 0) {
            this.getStage(stage);
          } else {
            this.getselectSpec(a.id);
            this.optionsFunction = [];
            this.optionsSpec = [];
          }
        }
      }
    },
    // 业态相关
    getStage(stage) {
      this.specValue = "";
      this.optionsFunction = stage;
      this.selectValue = stage[0].id;
      for (const a of stage) {
        if (a.dictTree) {
          this.selectPart();
        }
      }
    },
    // 区域
    selectPart() {
      this.specValue = "";
      this.treeData = [];
      this.optionsSpec = [];
      for (const a of this.optionsFunction) {
        if (a.id === this.selectValue) {
          // 有无树结构
          // 有
          if (!!a.dictTree && a.dictTree.length > 0) {
            this.optionsSpec = a.dictTree;
            this.specValue = a.dictTree[0].id;
            this.selectSpec();
          } else {
            // 无
            this.getselectSpec(a.id);
          }
        }
      }
    },
    async getselectSpec(id) {
      // 左边属性结构
      this.messageShow = false;
      this.messParams.queryKeyWord = "";
      this.treeData = [];
      this.loading = true;
      const result = await checkDrawingsService.checkDrawing(id);
      if (result.result === "0") {
        this.treeData = result.data;
        this.loading = false;
      }
    },
    // 专业
    async selectMajor() {
      const result = await checkDrawingsService.checkDrawing(this.specValue);
      if (result.result === "0") {
        this.treeData = result.data;
      }
    },
    //
    async getSelectMajor(id) {
      // 左边属性结构
      this.messageShow = false;
      this.messParams.queryKeyWord = "";
      this.treeData = [];
      const result = await checkDrawingsService.checkDrawing(id);
      if (result.result === "0") {
        this.treeData = result.data;
      }
    },
    choose() {
      if (this.infoTemp) {
        this.$message.success("已选择当前要点");
        window.chkImportCefSharpBrower && window.chkImportCefSharpBrower.passChkImport(this.infoTemp.mainPoint);
        this.handleClose();
      } else {
        this.$message.warning("请选择一条要点");
      }
    },
    // 选择审图要点
    chooseInfo(val, index) {
      console.log(val, index);
      if (val !== "暂无数据") {
        this.n = index;
        this.infoTemp = val;
        this.num = val.score;
      }
    },
    async selectSpec() {
      this.loading = true;
      const result = await checkDrawingsService.checkDrawing(this.specValue);
      if (result.result === "0") {
        this.treeData = result.data;
        this.loading = false;
      }
    },
    navSearch() {
      this.$refs.tree.filter(this.navValue);
    },
    // 筛选
    filterNode(value, data, node) {
      if (!value) return true;
      // 如果传入的value和data中的label相同说明是匹配到了
      if (data.cnName.indexOf(value) !== -1) {
        return true;
      }
      // 否则要去判断它是不是选中节点的子节点
      return this.checkBelongToChooseNode(value, data, node);
    },
    checkBelongToChooseNode(value, data, node) {
      const level = node.level;
      // 如果传入的节点本身就是一级节点就不用校验了
      if (level === 1) {
        return false;
      }
      // 先取当前节点的父节点
      let parentData = node.parent;
      // 遍历当前节点的父节点
      let index = 0;
      while (index < level - 1) {
        // 如果匹配到直接返回
        if (parentData.data.cnName.indexOf(value) !== -1) {
          return true;
        }
        // 否则的话再往上一层做匹配
        parentData = parentData.parent;
        index++;
      }
      // 没匹配到返回false
      return false;
    },

    handleClose() {
      this.messageItem = [];
      this.versionValue = "";
      this.selectValue = "";
      this.specValue = "";
      this.navValue = "";
      this.messageValue = "";
      this.imgPoint = false;
    },
    showDialog() {
      this.imgPoint = true;
    }
  }
};
</script>

<style scoped lang="scss">
.checkImgPoint {
  width: 100%;
  position: relative;
}
/deep/ .el-dialog {
  border-radius: 5px;
}
/deep/ .el-dialog__body {
  padding: 0px 20px 20px;
}
/deep/ .el-dialog__wrapper {
  width: 100% !important;
}
.checkImgPoint .searchHead {
  height: 70px;
}
.checkImgPoint .searchHead .searchForm {
  display: flex;
  justify-content: space-between;
  /deep/ .el-form-item--mini.el-form-item,
  .el-form-item--small.el-form-item {
    width: 30%;
  }
  /deep/ .el-form-item__label {
    padding: 0;
  }
}
.checkImgPoint .bottomInfo {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.checkImgPoint .bottomInfo .leftTree {
  width: 30%;
  .dataTree {
    overflow: auto;
    // height: 280px;
    width: 30%;
    position: absolute;
    top: 100px;
    bottom: 15px;
    overflow: auto;
  }
}
.checkImgPoint .bottomInfo .rightTable {
  width: 68%;
  .tableHead {
    height: 40px;
    padding: 15px 0px;
    width: 100%;
    margin-top: 3px;
    .headPart {
      float: left;
      padding: 6px;
    }
  }
  .infoUlContent li {
    border-bottom: 1px gainsboro solid;
    padding: 6px 0;
    line-height: 18px;
    cursor: pointer;
  }
  .infoUlContent .checked {
    background-color: gainsboro;
  }
  .infoContent {
    border-bottom: 1px gainsboro solid;
    padding: 6px 0;
    line-height: 18px;
    cursor: pointer;
  }
}
</style>
